import React, { FunctionComponent, useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Container, Typography } from "@mui/material";
import VizSensor from "react-visibility-sensor";
import ExperienceTimeline from "./subSections/ExperienceTimeline";
import { useLocation } from "react-router-dom";

const ContainerWrapperClass = {
  display: "flex",
  padding: "5% 0",
  minHeight: "65vh",
};

const RightSide = styled.div`
  flex: 1;
  padding: 10px;
`;

const LeftSide = styled.div`
  flex: 1 1 0%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  max-height: 50vh;
  overflow: auto;
`;

const Experience: FunctionComponent = () => {
  let [active, setActive] = useState(false);
  const containerRef = useRef(null);

  const location = useLocation();

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
        
          if (location.pathname !== "/#experience") {
            window.history.pushState(null, "", "/#experience");
          }
        }
      });
    }, options);

    const currentSectionRef = containerRef.current; // Store current ref value in a variable

    if (currentSectionRef) {
      observer.observe(currentSectionRef);
    }

    return () => {
      if (currentSectionRef) {
        observer.unobserve(currentSectionRef);
      }
    };
  }, [location]);

  return (
    <VizSensor
      onChange={(isVisible: boolean) => {
        setActive(isVisible);
      }}
    >
      <Container sx={ContainerWrapperClass} ref={containerRef}>
        <RightSide>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: "bold", color: "secondary.main" }}
          >
           Master of the Craft: 5+ Years of Experience, Numerous Awards and Certifications!
          </Typography>
          <p>
          For over 5 years, I've been immersed in the dynamic world of web and app development, 
          gaining a deep understanding of modern design trends and directions. 
          As a visionary and trusted software engineering partner, 
          I've collaborated with top-tier brands, seamlessly integrating with cross-functional teams. 
          Rest assured, you can expect exceptional results tailored to your expectations.
          </p>
        </RightSide>
        <LeftSide>
          <ExperienceTimeline />
        </LeftSide>
      </Container>
    </VizSensor>
  );
};

export default Experience;
